import React from 'react';
import '../App.css';
import Header from '../components/Header';
import Menu from '../components/Menu';
import Footer from '../components/Footer';
import AOS from "aos";
import "aos/dist/aos.css";
import WelcomeSmall from '../components/WelcomeSmall';
import ProducaoArt from '../components/ProducaoArt';

function prod_Art() {
  
    AOS.init();
  

  return (
    <div className="App">  
      <Header />
      <Menu />
      <WelcomeSmall />
      <ProducaoArt />
      <Footer/>
    </div>
  );
}

export default prod_Art;
